<template>
	<header class="header-tools">
		<div class="main-menu centered">
			<div class="menu">
				<div class="kosher_logo"></div>
				<a id="logo" href="/"></a>
				<div id="lower_header">
					<ul class="cats">
						<li v-for="link in menu" :key="link.link"><a :href="parseLink(link.link)" v-html="link.name"></a></li>
					</ul>
				</div>
				<div class="icons"></div>
			</div>
		</div>
	</header>
</template>
<script>
export default {
	computed: {
		menu() {
			return this.$store.state.menu || [];
		},
	},
	methods: {
		// the site links are relative to the site root, not to /joinus/
		parseLink(link) {
			if (this.isNull(link)) return "/";
			if (link.indexOf("http") === 0 || link.indexOf("/") === 0) return link;
			return "/" + link;
		},
	},
};
</script>
